module.exports = __webpack_public_path__ + "static/media/ron_avatar.1ab2a79b.jpg";